import { ApiStage } from '@xylabs/sdk-js'
import { getApiStage, useAsyncEffect } from '@xylabs/sdk-react'
import { XyoWorldGeotokenSettingsClient } from '@xyo-network/sdk-xyoworld-js'
import { useState } from 'react'

const useGeotokensSettings = (authToken?: string | null, api?: ApiStage) => {
  const [settings, setSettings] = useState<XyoWorldGeotokenSettingsClient[]>()
  useAsyncEffect(
    // eslint-disable-next-line react-hooks/exhaustive-deps
    async (isMounted) => {
      const data = await XyoWorldGeotokenSettingsClient.getAll(authToken, api ?? getApiStage())
      if (isMounted()) {
        console.log(`useGeotokensSettings: ${data.length}`)
        setSettings(data)
      }
    },
    [authToken, api],
  )
  console.log(`useGeotokensSettings:return: ${settings?.length}`)
  return settings
}

export default useGeotokensSettings
